// extracted by mini-css-extract-plugin
export var abc = "styles-module--abc--3335b";
export var desktop = "1340px";
export var errorMessage = "styles-module--errorMessage--a44fa";
export var flexWrapper = "styles-module--flexWrapper--385de";
export var formContainer = "styles-module--formContainer--787cb";
export var formOnLeft = "styles-module--formOnLeft--a8736";
export var giant = "2200px";
export var header = "styles-module--header--2c815";
export var inputField = "styles-module--inputField--7d143";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var nameAndEmailFields = "styles-module--nameAndEmailFields--89e83";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var submitButtonContainer = "styles-module--submitButtonContainer--d2c67";
export var successContainer = "styles-module--successContainer--0b108";
export var tablet = "769px";
export var text = "styles-module--text--6b489";
export var visible = "styles-module--visible--a6cd3";